import { useState, useEffect } from 'react';

const useDelayMount = (delay = 0) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const delayedMount = setTimeout(() => {
      !mounted && setMounted(true);
    }, delay);
    return () => clearTimeout(delayedMount);
  }, [delay, mounted]);

  return [mounted, setMounted];
};
export default useDelayMount;
